import { create } from 'zustand';
import securePersist from '@/utils/securePersist';

interface ProductSlugState {
  slug: string | null;
  setSlug: (slug: string) => void;
  clearSlug: () => void;
}

export const productSlugStore = create<ProductSlugState>()(
  securePersist(
    (set) => ({
      slug: null,
      setSlug: (slug) => set({ slug }),
      clearSlug: () => set({ slug: null }),
    }),
    { name: 'product-slug' },
  ),
);
